export enum Party {
    EMPLOYEE = 'employee',
    EMPLOYER = 'employer',
    PHYSICIAN = 'physician'
}